import api from "../../../lib/axios";

const BASE_URL = "/Client";

export const clientService = {
  getAll: async (params) => {
    const response = await api.get(`${BASE_URL}`, { params });
    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await api.get(`${BASE_URL}/search`, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  getLookup: async () => {
    const response = await api.get(`${BASE_URL}/lookup`);
    return response.data;
  },
  edit: async (id) => {
    const response = await api.get(`${BASE_URL}/edit/${id}`);
    return response.data;
  },

  create: async (formData) => {
    const response = await api.post(`${BASE_URL}`, formData);
    return response.data;
  },

  update: async (id, formData) => {
    const response = await api.put(`${BASE_URL}/${id}`, formData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  },

  changePublishStatus: async (id, isPublished) => {
    const response = await api.put(`${BASE_URL}/change-publish-status/${id}`, { isPublished });
    return response.data;
  },

  reorder: async (items) => {
    const response = await api.put(`${BASE_URL}/reorder`, items);
    return response.data;
  },

  uploadImage: async (clientId, formData) => {
    const response = await api.post(`${BASE_URL}/${clientId}/images`, formData);
    return response.data;
  },

  deleteImage: async (clientId, imageId) => {
    const response = await api.delete(`${BASE_URL}/${clientId}/images/${imageId}`);
    return response.data;
  },

  reorderImages: async (clientId, items) => {
    const response = await api.put(`${BASE_URL}/${clientId}/images/reorder`, items);
    return response.data;
  },
};
